// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"65":"4f9b1cd2","974":"2d513c07"}[chunkId] + ".js";
};